var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "basic-container",
    [
      _c(
        "el-row",
        { attrs: { span: 24 } },
        [
          _c("el-col", { attrs: { md: 4 } }, [
            _c(
              "div",
              { staticClass: "tree-position" },
              [
                _c("avue-tree", {
                  attrs: { option: _vm.treeOption, data: _vm.treeData },
                  on: { "node-click": _vm.nodeClick },
                }),
              ],
              1
            ),
          ]),
          _c("el-col", { attrs: { md: 20 } }, [
            _c(
              "div",
              {
                directives: [
                  {
                    name: "loading",
                    rawName: "v-loading",
                    value: _vm.saveLoading,
                    expression: "saveLoading",
                  },
                ],
                staticClass: "public-account-management clearfix",
              },
              [
                _c("div", { staticClass: "left" }, [
                  _c("div", { staticClass: "weixin-hd" }, [
                    _c("div", { staticClass: "weixin-title" }, [
                      _vm._v(
                        "\n              " +
                          _vm._s(_vm.menuName) +
                          "\n            "
                      ),
                    ]),
                  ]),
                  _c(
                    "div",
                    { staticClass: "weixin-menu menu_main clearfix" },
                    [
                      _vm._l(_vm.menu.button, function (item, i) {
                        return _c(
                          "div",
                          { key: i, staticClass: "menu_bottom" },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "menu_item el-icon-s-fold",
                                class: { active: _vm.isActive === i },
                                on: {
                                  click: function ($event) {
                                    return _vm.menuFun(i, item)
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(item.name) +
                                    "\n              "
                                ),
                              ]
                            ),
                            _vm.isSubMenuFlag === i
                              ? _c(
                                  "div",
                                  { staticClass: "submenu" },
                                  [
                                    _vm._l(
                                      item.sub_button,
                                      function (subItem, k) {
                                        return item.sub_button
                                          ? _c(
                                              "div",
                                              {
                                                key: k,
                                                staticClass:
                                                  "subtitle menu_bottom",
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass: "menu_subItem",
                                                    class: {
                                                      active:
                                                        _vm.isSubMenuActive ===
                                                        i + "" + k,
                                                    },
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.subMenuFun(
                                                          subItem,
                                                          i,
                                                          k
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(subItem.name) +
                                                        "\n                  "
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            )
                                          : _vm._e()
                                      }
                                    ),
                                    !item.sub_button ||
                                    item.sub_button.length < 5
                                      ? _c(
                                          "div",
                                          {
                                            staticClass:
                                              "menu_bottom menu_addicon",
                                            on: {
                                              click: function ($event) {
                                                return _vm.addSubMenu(i, item)
                                              },
                                            },
                                          },
                                          [
                                            _c("i", {
                                              staticClass: "el-icon-plus",
                                            }),
                                          ]
                                        )
                                      : _vm._e(),
                                  ],
                                  2
                                )
                              : _vm._e(),
                          ]
                        )
                      }),
                      _vm.menuKeyLength < 3
                        ? _c(
                            "div",
                            {
                              staticClass: "menu_bottom menu_addicon",
                              on: { click: _vm.addMenu },
                            },
                            [_c("i", { staticClass: "el-icon-plus" })]
                          )
                        : _vm._e(),
                    ],
                    2
                  ),
                  _c(
                    "div",
                    { staticClass: "save_div" },
                    [
                      _vm.permissions.mp_wxmenu_add
                        ? _c(
                            "el-button",
                            {
                              staticClass: "save_btn",
                              attrs: { type: "success", size: "small" },
                              on: { click: _vm.saveMenu },
                            },
                            [_vm._v("保存")]
                          )
                        : _vm._e(),
                      _vm.permissions.mp_wxmenu_push
                        ? _c(
                            "el-button",
                            {
                              staticClass: "save_btn",
                              attrs: { type: "info", size: "small" },
                              on: { click: _vm.publishMenu },
                            },
                            [_vm._v("发布")]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ]),
                _vm.showRightFlag
                  ? _c("div", { staticClass: "right" }, [
                      _c("div", { staticClass: "configure_page" }, [
                        _c(
                          "div",
                          [
                            _c("span", [_vm._v("菜单标识：")]),
                            _c("el-input", {
                              staticClass: "input_width",
                              attrs: {
                                placeholder: "请输入菜单KEY",
                                maxlength: _vm.nameMaxlength,
                                clearable: "",
                              },
                              model: {
                                value: _vm.tempObj.key,
                                callback: function ($$v) {
                                  _vm.$set(_vm.tempObj, "key", $$v)
                                },
                                expression: "tempObj.key",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "div",
                          { staticClass: "menu_content" },
                          [
                            _c("span", [_vm._v("菜单名称：")]),
                            _c("el-input", {
                              staticClass: "input_width",
                              attrs: {
                                placeholder: "请输入菜单名称",
                                maxlength: _vm.nameMaxlength,
                                clearable: "",
                              },
                              model: {
                                value: _vm.tempObj.name,
                                callback: function ($$v) {
                                  _vm.$set(_vm.tempObj, "name", $$v)
                                },
                                expression: "tempObj.name",
                              },
                            }),
                          ],
                          1
                        ),
                        _vm.showConfigurContent
                          ? _c("div", [
                              _c(
                                "div",
                                { staticClass: "menu_content" },
                                [
                                  _c("span", [_vm._v("菜单内容：")]),
                                  _c(
                                    "el-select",
                                    {
                                      staticClass: "menu_option",
                                      attrs: {
                                        clearable: "",
                                        placeholder: "请选择",
                                      },
                                      model: {
                                        value: _vm.tempObj.type,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.tempObj, "type", $$v)
                                        },
                                        expression: "tempObj.type",
                                      },
                                    },
                                    _vm._l(_vm.menuOptions, function (item) {
                                      return _c("el-option", {
                                        key: item.value,
                                        attrs: {
                                          label: item.label,
                                          value: item.value,
                                        },
                                      })
                                    }),
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm.tempObj.type === "view"
                                ? _c(
                                    "div",
                                    { staticClass: "configur_content" },
                                    [
                                      _c("span", [_vm._v("跳转链接：")]),
                                      _c("el-input", {
                                        staticClass: "input_width",
                                        attrs: {
                                          placeholder: "请输入链接",
                                          clearable: "",
                                        },
                                        model: {
                                          value: _vm.tempObj.url,
                                          callback: function ($$v) {
                                            _vm.$set(_vm.tempObj, "url", $$v)
                                          },
                                          expression: "tempObj.url",
                                        },
                                      }),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm.tempObj.type === "miniprogram"
                                ? _c(
                                    "div",
                                    { staticClass: "configur_content" },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "applet" },
                                        [
                                          _c("span", [
                                            _vm._v("小程序的appid："),
                                          ]),
                                          _c("el-input", {
                                            staticClass: "input_width",
                                            attrs: {
                                              placeholder:
                                                "请输入小程序的appid",
                                              clearable: "",
                                            },
                                            model: {
                                              value: _vm.tempObj.appid,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.tempObj,
                                                  "appid",
                                                  $$v
                                                )
                                              },
                                              expression: "tempObj.appid",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "div",
                                        { staticClass: "applet" },
                                        [
                                          _c("span", [
                                            _vm._v("小程序的页面路径："),
                                          ]),
                                          _c("el-input", {
                                            staticClass: "input_width",
                                            attrs: {
                                              placeholder:
                                                "请输入小程序的页面路径，如：pages/index",
                                              clearable: "",
                                            },
                                            model: {
                                              value: _vm.tempObj.pagepath,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.tempObj,
                                                  "pagepath",
                                                  $$v
                                                )
                                              },
                                              expression: "tempObj.pagepath",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "div",
                                        { staticClass: "applet" },
                                        [
                                          _c("span", [_vm._v("备用网页：")]),
                                          _c("el-input", {
                                            staticClass: "input_width",
                                            attrs: {
                                              placeholder:
                                                "不支持小程序的老版本客户端将打开本网页",
                                              clearable: "",
                                            },
                                            model: {
                                              value: _vm.tempObj.url,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.tempObj,
                                                  "url",
                                                  $$v
                                                )
                                              },
                                              expression: "tempObj.url",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _c("p", { staticClass: "blue" }, [
                                        _vm._v(
                                          "tips:需要和公众号进行关联才可以把小程序绑定带微信菜单上哟！"
                                        ),
                                      ]),
                                    ]
                                  )
                                : _vm._e(),
                              _vm.tempObj.type === "view_limited"
                                ? _c(
                                    "div",
                                    { staticClass: "configur_content" },
                                    [
                                      _c(
                                        "el-row",
                                        [
                                          _vm.tempObj &&
                                          _vm.tempObj.content &&
                                          _vm.tempObj.content.newsItem
                                            ? _c(
                                                "div",
                                                { staticClass: "select-item" },
                                                [
                                                  _c("WxNews", {
                                                    attrs: {
                                                      "obj-data":
                                                        _vm.tempObj.content
                                                          .newsItem,
                                                    },
                                                  }),
                                                  _c(
                                                    "el-row",
                                                    { staticClass: "ope-row" },
                                                    [
                                                      _c("el-button", {
                                                        attrs: {
                                                          type: "danger",
                                                          icon: "el-icon-delete",
                                                          circle: "",
                                                        },
                                                        on: {
                                                          click:
                                                            _vm.deleteTempObj,
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              )
                                            : _vm._e(),
                                          !_vm.tempObj.content ||
                                          !_vm.tempObj.content.newsItem
                                            ? _c(
                                                "div",
                                                [
                                                  _c(
                                                    "el-row",
                                                    [
                                                      _c(
                                                        "el-col",
                                                        {
                                                          staticStyle: {
                                                            "text-align":
                                                              "center",
                                                          },
                                                          attrs: { span: 24 },
                                                        },
                                                        [
                                                          _c(
                                                            "el-button",
                                                            {
                                                              attrs: {
                                                                type: "success",
                                                              },
                                                              on: {
                                                                click:
                                                                  _vm.openMaterial,
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                "素材库选择"
                                                              ),
                                                              _c("i", {
                                                                staticClass:
                                                                  "el-icon-circle-check el-icon--right",
                                                              }),
                                                            ]
                                                          ),
                                                        ],
                                                        1
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              )
                                            : _vm._e(),
                                          _c(
                                            "el-dialog",
                                            {
                                              attrs: {
                                                title: "选择图文",
                                                visible: _vm.dialogNewsVisible,
                                                width: "90%",
                                              },
                                              on: {
                                                "update:visible": function (
                                                  $event
                                                ) {
                                                  _vm.dialogNewsVisible = $event
                                                },
                                              },
                                            },
                                            [
                                              _c("WxMaterialSelect", {
                                                attrs: {
                                                  "obj-data": {
                                                    repType: "news",
                                                    appId: _vm.checkAppId,
                                                  },
                                                },
                                                on: {
                                                  selectMaterial:
                                                    _vm.selectMaterial,
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm.tempObj.type === "click" ||
                              _vm.tempObj.type === "scancode_waitmsg"
                                ? _c(
                                    "div",
                                    { staticClass: "configur_content" },
                                    [
                                      _vm.hackResetWxReplySelect
                                        ? _c("WxReplySelect", {
                                            attrs: { "obj-data": _vm.tempObj },
                                          })
                                        : _vm._e(),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ])
                          : _vm._e(),
                        _c(
                          "div",
                          { staticClass: "delete_btn" },
                          [
                            _vm.permissions.mp_wxmenu_del
                              ? _c(
                                  "el-button",
                                  {
                                    attrs: {
                                      size: "mini",
                                      type: "danger",
                                      icon: "el-icon-delete",
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.deleteMenu(_vm.tempObj)
                                      },
                                    },
                                  },
                                  [_vm._v("删除当前菜单\n              ")]
                                )
                              : _vm._e(),
                          ],
                          1
                        ),
                      ]),
                    ])
                  : _vm._e(),
                !_vm.showRightFlag
                  ? _c("div", { staticClass: "right" }, [
                      _c("p", [_vm._v("请选择菜单配置")]),
                    ])
                  : _vm._e(),
              ]
            ),
          ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }